import { render } from "./AppHeaderDropdownTasks.vue?vue&type=template&id=15668771"
import script from "./AppHeaderDropdownTasks.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownTasks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\BeMoved\\datafind-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__